import React from 'react'
import { Menu, X } from 'lucide-react'

// Phone slide-in menu (left drawer) used by the admin pages and the
// assistant case list. `content` is the list of items - use SidePanelItem
// for the standard look.
export function SidePanelItem({ active = false, danger = false, onClick, children }) {
  return (
    <button
      type='button'
      onClick={onClick}
      className={`w-full text-left bg-transparent cursor-pointer border-0 border-l-2 py-3.5 px-5 font-plexsans text-[14px] leading-none ${active ? 'border-brass bg-brass/[.08] font-semibold text-navy' : `border-transparent font-normal ${danger ? 'text-danger' : 'text-navy/[.75]'}`}`}
    >
      {children}
    </button>
  );
}

// White bar under the header on phones: which section you're on + a Menu button.
export function MobileSectionBar({ eyebrow, title, onMenu }) {
  return (
    <div className='col-span-6 w-full flex items-center justify-between gap-3 py-3 px-4 bg-white border-b border-navy/[.1] font-plexsans'>
      <div className='flex flex-col gap-1 min-w-0'>
        {eyebrow && <span className='font-plexmono font-medium text-[10.5px] leading-none tracking-[.08em] uppercase text-brass'>{eyebrow}</span>}
        <span className='font-semibold text-[15px] leading-[1.25] text-navy truncate'>{title}</span>
      </div>
      <button type='button' onClick={onMenu}
        className='flex-none inline-flex items-center gap-1.5 font-semibold text-[13px] leading-none text-navy bg-white border border-navy/[.2] rounded-md py-2.5 px-3 cursor-pointer'>
        <Menu className='w-4 h-4'/> Menu
      </button>
    </div>
  );
}

function SidePanelMobile({content, openMenu, setOpenMenu, title = 'Menu', eyebrow}) {
  return (
    <div>
       <div
            onClick={() => setOpenMenu(false)}
            className={`lg:hidden fixed inset-0 bg-navy/[.45] z-40 transition-opacity duration-300 ${openMenu ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
            />
            <aside
            className={`fixed lg:hidden top-0 left-0 z-50 h-full w-[85vw] max-w-[320px] bg-cream font-plexsans flex flex-col transform transition-transform duration-300 ease-in-out ${openMenu ? 'translate-x-0 shadow-[0_24px_60px_-20px_rgba(20,33,61,.5)]' : '-translate-x-full shadow-none'}`}
            >
              <div className='flex-none flex items-start justify-between gap-4 py-[18px] px-5 bg-white border-b border-navy/[.1]'>
                <div className='flex flex-col gap-1.5 min-w-0'>
                  {eyebrow && <span className='font-plexmono font-medium text-[11px] leading-none tracking-[.08em] uppercase text-brass'>{eyebrow}</span>}
                  <span className='font-spectral text-[19px] leading-[1.25] text-navy'>{title}</span>
                </div>
                <button type='button' onClick={() => setOpenMenu(false)} title='Close' className='flex bg-transparent border-0 cursor-pointer text-navy p-0.5'>
                  <X className='w-[18px] h-[18px]' strokeWidth={2.2}/>
                </button>
              </div>
              <nav className='flex-1 overflow-y-auto py-3 flex flex-col'>
                {content}
              </nav>
            </aside>
    </div>
  )
}

export default SidePanelMobile
